// extracted by mini-css-extract-plugin
module.exports = {"noScroll":"NoScroll-noScroll-2tKM9"};